import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { gradients } from '../../themes/gradients';

/**
 * Badge quadrado-arredondado com fundo em gradiente + glow tingido na
 * mesma cor - a peça base de todo o visual novo (dashboards, cards de
 * relatório, headers de página). `gradient` aceita uma chave de
 * `themes/gradients.js` ('blue' | 'teal' | 'amber' | 'coral' | 'graphite')
 * ou um objeto `{ full, main }` custom.
 */
const GradientIconBadge = ({ icon: Icon, gradient = 'blue', size = 52, iconSize, sx = {} }) => {
    const g = typeof gradient === 'string' ? gradients[gradient] || gradients.blue : gradient;

    return (
        <Box
            sx={{
                width: size,
                height: size,
                borderRadius: `${Math.round(size * 0.32)}px`,
                background: g.full,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: `0 8px 20px ${g.main}4d, 0 2px 6px ${g.main}33`,
                transition: 'transform 0.2s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.2s ease',
                flexShrink: 0,
                '&:hover': {
                    transform: 'translateY(-2px) scale(1.04)',
                    boxShadow: `0 12px 28px ${g.main}66, 0 4px 10px ${g.main}40`
                },
                ...sx
            }}
        >
            {Icon && <Icon size={iconSize || Math.round(size * 0.46)} color="#fff" strokeWidth={2} />}
        </Box>
    );
};

GradientIconBadge.propTypes = {
    icon: PropTypes.elementType,
    gradient: PropTypes.oneOfType([PropTypes.oneOf(['blue', 'teal', 'amber', 'coral', 'graphite']), PropTypes.object]),
    size: PropTypes.number,
    iconSize: PropTypes.number,
    sx: PropTypes.object
};

export default GradientIconBadge;
